@if (tickets$ | async; as tickets) {
  <div class="passenger-component-container">
    @for (ticket of (isExpanded ? tickets : tickets.slice(0, 3)); track trackByType($index, ticket); let isLast = $last) {
      <div class="passenger-type" [class.no-border]="isLast">
        <div class="passenger-type-info">
          <div class="passenger-type-label">{{ getPassengerLabel(ticket) | translate }}</div>
          <div class="passenger-type-price">{{ ticket.price | price: locale}}</div>
        </div>
        <div class="passenger-type-controls">
          <app-ticket-button
            action="decrease"
            [disabled]="ticket.count === 0"
            (clicked)="decrease(ticket)">
          </app-ticket-button>
          <div class="passenger-type-count notranslate">{{ ticket.count }}</div>
          <app-ticket-button
            action="increase"
            [disabled]="ticket.count > 29"
            (clicked)="increase(ticket)">
          </app-ticket-button>
        </div>
      </div>
    }
    @if (tickets.length > 3) {
      <div>
        <button class="expand-btn" (click)="toggleExpand()">
          <i class="fa-solid" [ngClass]="isExpanded ? 'fa-angle-up' : 'fa-angle-down'"></i>
          {{ isExpanded ? ('web.showLess' | translate) : ('web.showMore' | translate) }}
        </button>
      </div>
    }
  </div>
}